import {GET_HOME_DATA_API} from "../constants/Home";

const initialState = {
    loading: false,
    homeBanners: [],
    deals: [],
    ordering: [],
};

export default (state = initialState, action = {payload : {}}) => {
    switch (action.type) {
        case GET_HOME_DATA_API:
            let homeBanners = (action && action.payload) ? action.payload.homeBanners : [];
             let deals = (action && action.payload) ? action.payload.deals : [];
            let ordering = (action && action.payload) ? action.payload.ordering : [];
            return {...state, loading: action.loading, homeBanners, deals, ordering};
        default:
            return state;
    }
};
